// extracted by mini-css-extract-plugin
export default {"voiceRecorder":"VoiceRecorder_voiceRecorder__oYwAg"};